import {View, Text, TouchableOpacity, ActivityIndicator} from 'react-native';
import React from 'react';
import {responsiveFontSize} from 'react-native-responsive-dimensions';

import {theme} from '../constants';

type Props = {
  title: string;
  loading?: boolean;
  onPress?: () => void;
  containerStyle?: object;
  transparent?: boolean;
  disabled?: boolean;
};

const Button: React.FC<Props> = ({
  title,
  onPress,
  loading = false,
  containerStyle,
  transparent = false,
  disabled = false,
}): JSX.Element => {
  const isDisabled = loading || disabled;

  return (
    <View style={containerStyle}>
      <TouchableOpacity
        style={{
          width: '100%',
          height: 50,
          borderRadius: 10,
          borderWidth: transparent ? 1 : 0,
          borderColor: theme.colors.accentPrimary,
          backgroundColor: transparent ? '#FAFCFE' : theme.colors.accentPrimary,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isDisabled ? 0.5 : 1,
        }}
        onPress={onPress}
        disabled={isDisabled}
      >
        <View
          style={{
            width: '100%',
            height: 50,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {loading && (
            <ActivityIndicator
              color={transparent ? theme.colors.textPrimary : theme.colors.backgroundPrimary}
              size='small'
            />
          )}
          {!loading && (
            <Text
              style={{
                color: transparent
                  ? theme.colors.accentPrimary
                  : theme.colors.backgroundPrimary,
                textTransform: 'capitalize',
                ...theme.fonts.DMSans_700Bold,
                fontSize: 14,
              }}
            >
              {title}
            </Text>
          )}
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default Button;
